export default "__VITE_ASSET__B3itzK9L__"